import component from '@123/druid/dist/Framework/Decorators/Component';
import {inject} from '@123/druid/dist/Framework/Decorators/Inject';
import onClick from '@123/druid/dist/Framework/Decorators/OnClick';
import View from '@123/druid/dist/Framework/View/View';
import type DelegateEvent from '@123/druid/dist/Types/DelegateEvent';
import DialogFactory from '@Component/Window/DialogFactory';
import FaqService from '@Module/Faq/Service/FaqService';

@component
export default class FaqFeedbackView extends View {
    constructor(@inject(FaqService) private faqService: FaqService) {
        super();
    }

    @onClick('faq-feedback-button')
    protected async onFeedbackButtonClick(event: DelegateEvent): Promise<void> {
        const target = event.delegateTarget;
        const categoryId = target.datamap().getInt('categoryId');
        const questionId = target.datamap().getInt('questionId');

        const {content, title} = await this.faqService.getFaqItem(categoryId, questionId);

        await DialogFactory.contentDialog(content, title, 700, 400);
    }
}
